import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Box, Grid, Typography} from "@mui/material";
import {ImageSeeker} from "@ui-seeker/core";
import ProductPagesDetailsVideosModal from "./Modal";


export default function ProductPagesDetailsModalVideosContent({ videos=[], data }) {
    const openModal = useSignal(false)
    const haveVideos = videos.length > 0

    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <Typography variant="subtitle2">
                Videos: { !haveVideos && "--" }
            </Typography>
        </Grid>

        { !!haveVideos && <Grid item xs={12} sx={{ display: 'flex', gap: .5, cursor: 'pointer', }} onClick={() => openModal.value = true}>
            { videos.map(({ position }) => <Box key={position}>
                <ImageSeeker src="/images/Video.jpg" sx={{ height: 50 }} />
            </Box>) }
        </Grid> }

        <ProductPagesDetailsVideosModal
            isOpen={openModal.value}
            controller={() => openModal.value = false}
            data={data}
        />
    </Grid>
}